module.exports = __webpack_public_path__ + "static/media/newskyline-tour-2.06cf4c65.jpg";